/**
 * Admin API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LocationFormAssignmentSummary { 
    locationId?: string;
    locationName?: string;
    assignedFormId?: number;
    assignedFormName?: string;
    active?: boolean;
    usesPracticeDefault?: boolean;
    assignmentStatus?: LocationFormAssignmentSummary.AssignmentStatusEnum;
}
export namespace LocationFormAssignmentSummary {
    export const AssignmentStatusEnum = {
        Default: 'DEFAULT',
        Override: 'OVERRIDE',
        Inactive: 'INACTIVE',
        Unassigned: 'UNASSIGNED'
    } as const;
    export type AssignmentStatusEnum = typeof AssignmentStatusEnum[keyof typeof AssignmentStatusEnum];
}


